import React from 'react';
import ReactDOM from 'react-dom'; // ✅ React 17 style
import App from './App';
import reportWebVitals from './reportWebVitals';
import './style/main.scss';
import './style/landing.scss';

import { BrowserRouter } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap/dist/js/bootstrap.js';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

ReactDOM.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>,
  document.getElementById('root') // ✅ classic render target
);

reportWebVitals();
